import adminNav from "./admin";

const navigation = [...adminNav];

export default navigation;
